import { FC } from 'react';
import { Stack } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import SunshineCard from 'components/_core/SunshineCard';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import Text from 'components/_core/Text';

import locales from './locales';

interface TemplateDownloadRowProps {
  downloadUrl: string;
  fileTypeLabel: string;
  description: string;
}

const TemplateDownloadRow: FC<TemplateDownloadRowProps> = ({
  description,
  downloadUrl,
  fileTypeLabel,
}) => (
  <SunshineCard>
    <SunshineCard.Slot name="aside">
      <SquircleIcon name="file" />
    </SunshineCard.Slot>

    <SunshineCard.Content>
      <Stack spacing="space-4">
        <Text variant="primary">{fileTypeLabel}</Text>
        <Text size="sm">{description}</Text>
      </Stack>
    </SunshineCard.Content>

    <SunshineCard.Slot name="action">
      <Button as="a" href={downloadUrl} size="sm" variant="tertiary">
        {locales.downloadTemplate}
      </Button>
    </SunshineCard.Slot>
  </SunshineCard>
);
export default TemplateDownloadRow;
